import styled from 'styled-components';

const Overline = styled.span`
  filter: var(--theme-overline-filter);
`;

export default Overline;
